import React, { useEffect, useRef, useState } from "react";
import { Link as RouterLink } from "react-router-dom/dist";
import { AppBar, Box, Button, IconButton, Toolbar } from "@mui/material";
import NavbarDrawer from "./navbar-drawer";
//import { navbarList } from "../../utils/navbar-items";
//import { divisionItemsList } from "../../utils/division-items";
//import { onlineServiceItemsList } from "../../utils/online-services-items";
//import { generalInfoItemsList } from "../../utils/general-info-items";
import MenuTemplate from "./styled-menus";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import IconNavContainer from "./icon-nav-container";
import { getDataFromCmsApi } from "../../api/contentful-service";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Navigation() {

    const [navbarList, setNavbarList] = useState([]);
    const [iconMenuList, setIconMenuList] = useState([]);

    const [openSubMenu, setOpenSubMenu] = useState(null);

    const [bottomAnchor, setBottomAnchor] = useState(null);
    const navbarRef = useRef(null);

    const handleMenuClick = (menuName) => {
        setOpenSubMenu(menuName);
    };

    const handleCloseMenu = () => {
        setOpenSubMenu(null);
    };

    useEffect(() => {
        getData();

        if (navbarRef.current) {
            const bottomPosition = navbarRef.current.getBoundingClientRect().bottom;
            setBottomAnchor(bottomPosition);
        }
    }, []);

    const getData = async () => {

        const navigation = await getDataFromCmsApi("Navigation");

        const headerMenu = navigation.find(item => item.name === "Header Menu"); 
        const iconMenu = navigation.find(item => item.name === "Icon Menu");

        const navbarList = headerMenu.items.map(item => ({
            subheader: item.name,
            subheaderLink: item.link,
            icon: <FontAwesomeIcon icon={item.icon} />,
            children: item.children ? item.children.map(child => ({
                subheader: child.name,
                subheaderLink: child.link,
                items: child.children ? child.children.map(grandChild => ({
                    item: grandChild.name,
                    itemLink: grandChild.link,
                })) : [],
                icon: <FontAwesomeIcon icon={child.icon} />
            })) : []
        }));

        const iconMenuList = iconMenu.items.map(item => ({
            subheader: item.name,
            icon: <FontAwesomeIcon icon={item.icon} />
        }));

        setNavbarList(navbarList);
        setIconMenuList(iconMenuList);
    }

    const useStyles = {
        button: {
            color: "white",
            textAlign: "center",
            height: "100%",
            "&:hover": {
                color: "#cd9e0c",
                // textDecoration: "underline",
            },
            fontSize: {
                xs: "0.65rem",
                sm: "0.65rem",
                md: "0.65rem",
                lg: "0.785rem",
                xl: "0.875rem",
            },
            padding: {
                xs: "4px",
                sm: "6px",
                md: "8px",
                lg: "10px",
                xl: "12px",
            },
        },
    };

 
    return (
     
        <AppBar ref={navbarRef} className="position-sticky">
            <Toolbar disableGutters>
                <Box className="nav-wrapper" sx={{ display: { xs: "none", lg: "flex" } }}>
                    <IconButton className="nav-logo-wrapper" color="inherit" aria-label="menu">
                        <img className="nav-logo" src="/assets/logos/sb-logo-full-color.png" alt="SBC ATC Logo" />
                    </IconButton>
                    <div className="navbar-buttons">
                        {navbarList.map((item, i) => (
                            <Button
                                key={i}
                                variant="Text"
                                component={RouterLink}
                                to={item.subheaderLink}
                                onMouseOver={() => handleMenuClick(item.subheader)}
                                onMouseLeave={handleCloseMenu}
                                sx={useStyles.button}
                            >
                                {item.subheader}
                                {item.children.length > 0 && (
                                    openSubMenu === item.subheader ? (
                                        <ExpandMore className="ms-1" />
                                    ) : (
                                        <ExpandLess className="ms-1" />
                                    )
                                )}
                            </Button>
                        ))}

                        {navbarList.map((item, i) => (
                            item.children.length > 0 && (
                                <MenuTemplate
                                    key={i}
                                    id={`${item.subheader.toLowerCase().replace(/\s+/g, '-')}-menu`}
                                    isOpen={openSubMenu === item.subheader}
                                    handleOpenMenu={() => handleMenuClick(item.subheader)}
                                    handleCloseMenu={handleCloseMenu}
                                    itemsList={item.children}
                                    bottomAnchor={bottomAnchor}
                                />
                            )
                        ))}
                    </div>
                  
                        <IconNavContainer
                            iconMenuList={iconMenuList}
                        />
                    
                   
                </Box>
                <Box className="nav-wrapper" sx={{ display: { sm: "flex", lg: "none" } }}>
                    <NavbarDrawer
                        drawerWidth={0}
                        navbarList={navbarList}
                        iconMenuList={iconMenuList}
                    ></NavbarDrawer>
                </Box>
            </Toolbar>
        </AppBar>
    );
}
Navigation.propTypes = {};
export default Navigation;
